export const ATTACHMENT_TILE_CLASS_NAME = 'kurama-attachment-tile'
export const ATTACHMENT_TILE_REMOVE_CLASS_NAME = 'kurama-attachment-tile-remove'
